import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'react-recompose';
import intersection from 'lodash/intersection';

import {
  isCaminoEventsEnabled,
  getAllowedSubscriptions,
} from '../../utils/college-events';
import SubscriptionModule from '../SubscriptionModule';
import { withEnabledFeatures } from '../../utils/features';
import ticketSvg from '../../containers/SubscriptionsPage/ticket.svg';
import { withHEAccountSubscriptions } from '../../utils/subscriptions';
import { CAMINO_SUBSCRIPTION } from '../../containers/Authorization/constants';

const getDescription = (caminoEventsEnabled, subscriptions) => {
  if (caminoEventsEnabled) {
    if (subscriptions.length === 2) {
      return 'Manage college events and publish within Naviance & Camino.';
    }
    if (subscriptions.includes(CAMINO_SUBSCRIPTION)) {
      return 'Manage college events and publish within Camino.';
    }
    return 'Manage college events and publish within Naviance.';
  }
  return 'Manage college events and publish within Naviance.';
};

const getCollegeEventProps = (caminoEventsEnabled, subscriptions) => ({
  color: 'darkcyan',
  category: 'presence',
  title: 'Events',
  description: getDescription(caminoEventsEnabled, subscriptions),
  buttonLabel: 'Publish',
  image: ticketSvg,
  link: '/college-events/',
});

const CollegeEventsSubscriptionModule = (props) => {
  const caminoEventsEnabled = isCaminoEventsEnabled(props.enabledFeatures);
  const allowedSubscriptions = getAllowedSubscriptions(caminoEventsEnabled);
  const subscriptions = intersection(
    allowedSubscriptions,
    props.heAccount.activeSubscriptions,
  );

  return subscriptions.length ? (
    <SubscriptionModule
      {...getCollegeEventProps(caminoEventsEnabled, subscriptions)}
    />
  ) : (
    <SubscriptionModule
      showUpgrade
      name="events"
      onTriggerUpgrade={props.onTriggerUpgrade}
      {...getCollegeEventProps(caminoEventsEnabled, subscriptions)}
    />
  );
};
CollegeEventsSubscriptionModule.propTypes = {
  heAccount: PropTypes.object,
  onTriggerUpgrade: PropTypes.func,
  enabledFeatures: PropTypes.arrayOf(PropTypes.string),
};

export default compose(
  withEnabledFeatures,
  withHEAccountSubscriptions,
)(CollegeEventsSubscriptionModule);
